@use "../../styles/breakpoint.module" as *;

.wrapper {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: subgrid;
    position: relative;
    height: 200vh;
}

.root {
    align-content: center;
    overflow: hidden;
}

.standalone {
    grid-column: 1 / -1;
    display: grid;
    grid-template-columns: subgrid;
    position: sticky;
    top: 0;
    height: 100vh;
}

.controlled {
    composes: grid from "../../styles/layout.module.scss";
    position: absolute;
    inset: 0;
    height: 100%;

    .videoControl {
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.5s ease;
    }

    :global([data-fullscreen]) & .videoControl {
        opacity: 1;
        pointer-events: auto;
    }
}

.mediaContainer {
    position: absolute;
    inset: 0;
    z-index: 0;
    filter: brightness(calc(1 - 0.6 * var(--effect-progress, 0)));

    > * {
        width: 100%;
        height: 100%;
    }

    video,
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
}

.media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.content {
    grid-column: col-start 3 / col-end 10;
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: var(--spacer-24);
    color: var(--white);
    will-change: opacity, transform;
    opacity: var(--effect-progress, 0);
    transform: translateY(calc(100px * (1 - var(--effect-progress, 0))));

    @media ($below-tablet) {
        grid-column: col-start 2 / col-end 11;
    }

    @media ($below-mobile) {
        grid-column: content;
    }
}

.text {
    color: var(--white);
    text-shadow: 0 2px 8px var(--transparent-20);
}

.videoControl {
    position: absolute;
    right: var(--spacer-16);
    bottom: var(--spacer-16);
    border-radius: var(--border-radius-full);
    background: var(--transparent-20);
    display: flex;
    padding: var(--spacer-12);
    justify-content: center;
    align-items: center;
    border: none;
    cursor: pointer;
    z-index: 3;
    transition:
        background 0.2s ease,
        opacity 0.5s ease;

    svg {
        width: var(--spacer-24);
        height: var(--spacer-24);
        color: var(--white);
    }

    &:hover {
        background: var(--transparent-40);
    }

    &:focus-visible {
        outline: 2px solid var(--white);
        outline-offset: 2px;
    }
}
